export function Spinner({ size = 20 }: { size?: number }) {
  return (
    <span
      role="status"
      aria-label="Lädt"
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        border: '2px solid var(--surface-border-strong)',
        borderTopColor: 'var(--accent-10)',
        animation: 'ntl-spin 0.7s linear infinite',
      }}
    />
  )
}
